

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';



declare var $: any;
declare var kendo: any;
//Apps DeploymentTest Comment
@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {
  public checked = true;
  title = 'Registration-Portal';
  responseOutput = 'Please enter your credentials.';
  currentTab="";
  guid="";
  validateEmailIcon=false;
  enableUpdateButn=false;
  emailOk=false;
  userUpdated=false;

  showSpinner=false;
  showSpinnerUser=false;
  timer = null;
  cardWidth=100;
  showNavigationButton=false;

    user: InternalUserModel={
    _agentId:"",
    _agentGuid:"",
    _username:"",
    _email:"",
    _emailTwo:"",
    _phone:"",
    _phone2:"",
    _agentName :"",
    _password :"",
    _confPassword :"",
    _AgentAddress1 :"",
    _AgentAddress2 :"",
    _AgentAddress3 :"",
    _AgentAddress4 :"",
    _AgentAddress5 :"",
    _fax:"",
    _business:"",
    _contact:"",
  }


  constructor(public _authService:AuthService, private router: Router, private notificationService: Notification_Service, private activatedRoute: ActivatedRoute) {
    // String.prototype.matchAll()
   }

  ngOnInit() {
    this._authService.selectedUser.subscribe(x=>{
      if(x){
        this.user =x;
        this.user._agentName = x._agentName;
      }
    });

    $(document).ready(function () {
      $("#authentication-wrapper").hover(function () {
        kendo.fx($("#authentication-wrapper")).zoom("in").startValue(1).endValue(1.05).play();
      }, () => {
        kendo.fx($("#authentication-wrapper")).zoom("out").endValue(1).startValue(1.05).play();
      });
    })
    this.activatedRoute.params.subscribe(params => {
      this.guid = params['id']; //Value passed in the URL should be a GUID
      if(this.guid)this._authService.ValidateEmailRecoveryGuid(this.guid)
   });
  }

  confirmEmail() {
   this.showSpinner =true
   this._authService.confirmEmailUpdate( this._authService._emailToUpdate).subscribe((res:any) => {
     this.showSpinner =false;
     this.showNavigationButton= true;
     this.notificationService.successNotif("Your Email was confirmed and Updated to (" + res.replacementEmail +  ") successfuly." , false);
     this.userUpdated=true;
    // setTimeout(function () {
    //   window.close();
    // }, 5000)



    },
    error =>{
      this.showSpinner =false;
        this.notificationService.errorNotif("There was an error confirming the email.");
    });
  }

  navigateToLogin(){
    this.router.navigateByUrl('/sign-in');
  }

  checkPassword(){  //implement service for error message
    //     r'^
    //   (?=.*?[A-Z])         // should contain at least one upper case
    //   (?=.*?[a-z])         // should contain at least one lower case
    //   (?=.*?[0-9])         // should contain at least one digit
    //   (?=.*?[#?!@$%^&*-_]) // should contain at least one Special character
    //   .{8,}                // Must be at least 8 characters in length  
    // $
    if(  this.user._password=== this.user._confPassword 
         && new RegExp(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$`).test(this.user._password)){
      this.enableUpdateButn =true;
    }
    else{
      this.enableUpdateButn =false;
    }
  }

  UpdatePassword(){
    this._authService.UpdatePassword(this.user._password).subscribe(data =>{
      this.notificationService.successNotif("Your password was Successfully Updated.", false);
      this.showNavigationButton= true;
    }, error=>{
      this.notificationService.errorNotif("We were unable to update your password, please contact the  system Admin.");
    })
  }
}
